"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var Icon = function (_a) {
    var url = _a.url, classes = _a.classes;
    return react_1.default.createElement("span", { className: classes.root, "aria-label": 'Item Icon' });
};
exports.default = (0, core_1.withStyles)({
    root: {
        flexShrink: 0,
        width: 36,
        height: 36,
        display: 'block',
        background: function (_a) {
            var url = _a.url;
            return "url('" + url + "') no-repeat 50%";
        }
    }
})(Icon);
//# sourceMappingURL=DetailedItemIcon.js.map